export default {
  backHome: 'Zpět na hlavní stránku',
  back: 'Zpět',

  notFound: {
    title: 'Stránka nenalezena',
    body: 'Stránka, kterou hledáte, neexistuje nebo byla přesunuta.',
  },

  forbidden: {
    title: 'Přístup odepřen',
    body: 'Jste přihlášeni, ale tato stránka je nepřístupná. Pokud si myslíte, že jde o chybu, kontaktujte podporu.',
  },

  server: {
    headlines: {
      maintenance: 'Hned se vrátíme',
      '500': 'Něco se pokazilo',
      other: 'Máme potíže s připojením',
    },
    details: {
      maintenance: 'KeyzoStore je krátce offline z důvodu údržby. Zkuste to prosím za několik minut.',
      '500': 'Došlo k neočekávané chybě. Byli jsme upozorněni — zkuste to prosím znovu.',
      other: 'Naše služba je dočasně nedostupná. Zkuste to prosím za chvíli.',
    },
    retry: 'Zkusit znovu',
  },
};
